// @ts-check
import React from 'react';
import { connect } from 'react-redux';
import CalendarActions from 'agent_portal/actions/CalendarActions';
import LocationField from '../../shared/LocationField';
import RepeatSectionFields from '../../shared/RepeatSectionFields';
import TimeRangeFields from '../../shared/TimeRangeFields';
import SlotRestrictionsFields from '../../shared/SlotRestrictionsFields';
import HForm, { ToggleSwitchField } from 'shared/containers/portal_layout/HForm';
import { reduxForm, formValueSelector } from 'utils/reduxFormWrapper';
import { createValidator, required } from 'utils/validation';
import classes from './NewSlotForm.module.scss';
import SpinnerButton from 'shared/components/SpinnerButton';

const validateForm = createValidator({
  locationId: required,
});

const REPEAT_SECTION_FEATURE_FLAG = false;

const newSlotFormSelector = formValueSelector('newSlot');
function newSlotFormMapStateToProps(state) {
  const locations = state.calendar.providerEmployments.find(
    pe => pe.providerEmploymentId === state.calendar.selectedProviderEmploymentId
  ).locations;
  return {
    showRepeatSection: newSlotFormSelector(state, 'repeat') && REPEAT_SECTION_FEATURE_FLAG, // TODO: make repeat section
    locationOptions: locations.map(l => ({ value: l.id, label: l.name })),
  };
}
const NewSlotForm = connect(newSlotFormMapStateToProps)(
  ({
    selectionStart,
    selectionEnd,
    showRepeatSection,
    handleSubmit,
    submitting,
    locationOptions,
    selectedLocationId,
  }) => (
    <HForm onSubmit={handleSubmit(CalendarActions.createSlot)}>
      <LocationField options={locationOptions} value={selectedLocationId} />
      <div style={{ textAlign: 'center', margin: '20px 0' }}>
        <TimeRangeFields selectionStart={selectionStart} selectionEnd={selectionEnd} />
      </div>

      {REPEAT_SECTION_FEATURE_FLAG && (
        <ToggleSwitchField
          name="repeat"
          label="Repeat?"
          showStateLabel
          onStateLabel="Yes"
          offStateLabel="No"
        />
      )}

      {showRepeatSection && (
        <RepeatSectionFields
          formValueSelector={newSlotFormSelector}
          selectionStart={selectionStart}
        />
      )}

      <SlotRestrictionsFields />

      <div className={classes.form_actions}>
        <SpinnerButton className="button is-link" type="submit" loading={submitting}>
          Create Slot
        </SpinnerButton>
      </div>
    </HForm>
  )
);

NewSlotForm.displayName = 'NewSlotForm';

export default reduxForm({
  form: 'newSlot',
  validate: validateForm,
})(NewSlotForm);
